import styled from "styled-components";

const AdWrap = styled.div`
  margin-top: ${({ theme }) => theme.space[2]};
  margin-bottom: ${({ theme }) => theme.space[2]};
  text-align: center;
`;

export default AdWrap;
